export default __webpack_public_path__ + "static/media/1.862eced2.jpg";